(ns manatee.qa.view.shared
  (:require [manatee.accounts :as accounts]
            [manatee.domain.edit :as edit]
            [manatee.domain.external :as external]
            [manatee.domain.task :as task]
            [manatee.routing.url :as url]
            [manatee.ui.subs :as ui-subs]
            [manatee.user.components :as user-components]
            [re-frame.core :as rf]
            [rothko.button.component :refer [button]]
            [rothko.panel.component :refer [panel]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Go back only is set on the pending page which uses qa components ;;;;;;;;;;;;
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(defn go-back-only? []
  (:go-back-only (url/query-params)))

(defn go-back-button
  []
  [button {:appearance #{:secondary :full-width}
           :on-click #(rf/dispatch [:navigate-back])}
   "Go back"])

(defn- ->cefr-level
  "lookup AMA score to get CEFR value"
  [score]
  (cond
    (nil? score) "Missing"
    (< score 1) "pre-A1"
    (< score 2) "A1"
    (< score 3) "A2"
    (< score 4) "B1"
    (< score 5) "B2"
    (< score 6) "C1"
    (= score 6) "C2"
    :else "Score out of range"))

(defn item-details
  "This component renders metadata about an item"
  [{:keys [task-name] :as _task-config}
   {:keys [id model score item-type account-id medium]}
   & {:keys [compact?]}]
  (let [{:keys [account-ids]} @(rf/subscribe [::ui-subs/config])
        account-name (accounts/account-namer account-ids)
        ama-score (cond (= :speech medium) (->cefr-level score)
                        (= :text medium) (external/raw-score->cefr-level score :cefr-level))]
    [panel {:appearance #{:simple}}
     [:div
      [:h5 "Item Details"]
      [:ul
       [:li [:span [:strong "ID: "] (str id)]]
       (when model
         [:li [:span [:strong "Model: "] (str (:name model) " ver. " (:version model))]])
       (when-not compact?
         [:li [:span [:strong "Account: "] (account-name account-id)]])
       (when-not compact?
         [:li [:span [:strong "Type: "] item-type]])
       [:li [:span [:strong "Task: "] task-name]]
       (when score
         [:li [:span [:strong "AMA Score: "] ama-score]])]]]))

(defn- previous-annotation
  [item task-config-id task-config]
  (some->> (:previous-annotations item)
           (filter #(= (:task-config-id %)
                       (task/previous-task-config-id task-config task-config-id)))
           first))

(defn- user-item-edit-link
  [user-id item-id]
  [:a {:href     "#"
       :on-click #(rf/dispatch [:navigate-to
                                [:manatee.qa.handlers/user-item-edits {:user-id user-id
                                                                       :item-id item-id}]])}
   item-id])

(defn edit-details
  "This component renders metadata about an edit (without showing scores or
   annotated text)"
  ([task-config edit]
   (edit-details task-config nil edit "Edit Details"))
  ([task-config
    {:keys [task-config-id]
     :as   item}
    {:keys [user status reason other-reason notes evaluator-edit?]
     :as   _edit}
    title]
   (let [reasons (get-in task-config [:data :answer :rejections :reasons])
         reason-string (edit/rejection-reason->string reasons reason)]
     [panel {:appearance #{:simple}}
      [:div
       [:h5 title]
       [:ul
        [:li [:span [:strong "Annotator: "] [user-components/full-name user]]]
        [:li [:span [:strong "Current status: "] status]]
        (when (#{:rejected :rejected-requires-approval} status)
          [:li [:span [:strong "Rejection Reason: "] reason-string]])
        (when other-reason
          [:li [:span [:strong "Rejection Comment: "] other-reason]])
        (when notes
          [:li [:span [:strong "Note: "] notes]])
        (when item
          (when-let [previous-annotation (previous-annotation item task-config-id task-config)]
            [:li [:span [:strong "Previous Annotation: "] (user-item-edit-link (get-in previous-annotation [:user :id])
                                                                               (get-in previous-annotation [:data :item-id]))]]))
        (when evaluator-edit?
          [:li [:span [:strong "Evaluator Edit: "] (str evaluator-edit?)]])]]])))
